import { render, staticRenderFns } from "./DebtAmountTag.vue?vue&type=template&id=91452e82&"
import script from "./DebtAmountTag.vue?vue&type=script&lang=js&"
export * from "./DebtAmountTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports